var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 24,
    viewBox: "0 0 144 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.561 13.0607C144.146 12.4749 144.146 11.5251 143.561 10.9393L134.015 1.3934C133.429 0.807611 132.479 0.807611 131.893 1.3934C131.308 1.97918 131.308 2.92893 131.893 3.51472L140.379 12L131.893 20.4853C131.308 21.0711 131.308 22.0208 131.893 22.6066C132.479 23.1924 133.429 23.1924 134.015 22.6066L143.561 13.0607ZM-6.55671e-08 13.5L142.5 13.5L142.5 10.5L6.55671e-08 10.5L-6.55671e-08 13.5Z",
    fill: "#CECCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/long-arrow.f14d0285c4301e4d671aff83208a7242.svg";
export { ForwardRef as ReactComponent };